import { Fragment } from "react";

import { useTranslation } from "react-i18next";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import CitySelect from "components/Inputs/CitySelect";
import CityMultiSelect from "components/Inputs/CityMultiSelect";
import ProvinceMultiSelect from "components/Inputs/ProvinceMultiSelect";

const CompanyAreaForm = (props) => {
  const { values, updateValues } = props;
  const { t } = useTranslation();

  return (
    <Fragment>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 12, md: 6 }}>
          <Grid container direction="row" spacing={1}>
            <Grid size={{ xs: 12 }}>
              <Typography variant="subtitle1">
                {t("Ensisijainen paikkakunta (viranomaistilastointi)")}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <CitySelect
                name="main_city"
                value={values?.main_city?.id || -1}
                updateValues={updateValues}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Typography variant="subtitle1">
                {t("Toissijaiset paikat (ei pakollinen)")}
              </Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <CityMultiSelect
                name="secondary_cities"
                value={values.secondary_cities}
                updateValues={updateValues}
              />
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Typography variant="subtitle1">{t("Kela-alueet")}</Typography>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <ProvinceMultiSelect
                name="kela_areas"
                value={values.kela_areas}
                updateValues={updateValues}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
};

export default CompanyAreaForm;
